export enum BodyType {
    SelfDefined,
    Status,
    ActualParameter
}
